export const TOOLBOX_ID = 'craft_toolbox';
export const TOOLBOX_DOCK_ID = 'craft_toolbox_dock';
export const TOOLBOX_CONTENT = 'toolbox-content';
